import React from 'react';
import PropTypes from 'prop-types';

import { Container, TitleText, TitleTextSpan } from './styles';

class PageText extends React.Component {
    render() {
        var { className, ContainerWidth, ElementType, FontColor, FontColorHover, FontFamily, FontSize, JustifyContent, Lowercase, NoMargin, NoWrap, OnClick, OnClickTarget, Text, TextAlign, Underline, Uppercase, WhiteSpace, WordBreak } = this.props;

        if (this.props.Console) console.log('Props: ', this.props);

        if (ElementType && ElementType.toLowerCase() === 'span') {
            return (
                <TitleTextSpan
                    className={className}
                    Clickable={OnClick ? true : false}
                    FontColor={FontColor}
                    FontColorHover={FontColorHover}
                    FontFamily={FontFamily}
                    FontSize={FontSize}
                    Lowercase={Lowercase}
                    NoWrap={NoWrap}
                    onClick={OnClick}
                    Underline={Underline}
                    Uppercase={Uppercase}
                    WhiteSpace={WhiteSpace}
                    WordBreak={WordBreak}
                >
                    {Text}
                </TitleTextSpan>
            );
        }

        return (
            <Container
                className={className}
                ContainerWidth={ContainerWidth}
                JustifyContent={JustifyContent}
                NoMargin={NoMargin}
                NoWrap={NoWrap}
                onClick={OnClickTarget === 'container' && OnClick ? OnClick : null}
                TextAlign={TextAlign}
                WhiteSpace={WhiteSpace}
                WordBreak={WordBreak}
            >
                <TitleText
                    Clickable={OnClick ? true : false}
                    FontColor={FontColor}
                    FontColorHover={FontColorHover}
                    FontFamily={FontFamily}
                    FontSize={FontSize}
                    Lowercase={Lowercase}
                    onClick={OnClickTarget !== 'container' && OnClick ? OnClick : null}
                    Underline={Underline}
                    Uppercase={Uppercase}
                >
                    {Text}
                </TitleText>
            </Container>
        );
    }
}

PageText.propTypes = {
    ContainerWidth: PropTypes.string,
    ElementType: PropTypes.string,
    FontColor: PropTypes.string,
    FontColorHover: PropTypes.string,
    FontFamily: PropTypes.string,
    FontSize: PropTypes.string,
    JustifyContent: PropTypes.string,
    Lowercase: PropTypes.bool,
    NoMargin: PropTypes.bool,
    NoWrap: PropTypes.bool,
    OnClick: PropTypes.func,
    OnClickTarget: PropTypes.string,
    Text: PropTypes.string.isRequired,
    TextAlign: PropTypes.string,
    Underline: PropTypes.bool,
    Uppercase: PropTypes.bool,
    WhiteSpace: PropTypes.string,
    WordBreak: PropTypes.string
};

export default PageText;